import React from "react";
import { Col, Card } from "antd";
import {
  AreaChart,
  Area,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid
} from "recharts";
import InsightsCard from "./insightChart";
import TradesSection from "./tradeChart";
const CustomStrategyTooltip = ({ payload, label }) => {
  if (payload && payload.length) {
    const value = payload[0].value;

    return (
      <div
        className="background-blur"
        style={{
          padding: "10px",
          width: "150px",
          textAlign: "left",
          color: "#000",
        }}
      >
        <p style={{ fontSize: "12px" }}>
          {value >= 0 ? "Profit" : "Loss"}
        </p>
        <p style={{ fontSize: "12px" }}>Label: {label}</p>
        <p style={{ fontSize: "12px" }}>
          Value: ₹ {Number(value).toFixed(2)}
        </p>
      </div>
    );
  }
  return null;
};
const DashboardCharts = ({ data }) => {
// console.log(data);

  const areaData = data?.equity_curve || []
const barData = [
  {
    name: "Wins",
    value: data?.win_loss?.wins?.length || 0,
  },
  {
    name: "Loss",
    value: data?.win_loss?.losses?.length || 0,
  },
];  const lineData = data?.score || []

  return (
    <>
      {/* Lincfolio Score */}
<Col xs={24} lg={12}>        <Card title="Lincfolio Score">
          <ResponsiveContainer width="100%" height={250}>
            <LineChart data={lineData}>
              {/* <CartesianGrid strokeDasharray="3 3" /> */}
              <XAxis dataKey="week" />
              <YAxis />
<Tooltip content={<CustomStrategyTooltip />} />
              <Line
                type="monotone"
                dataKey="score"
                stroke="#8e44ad"
                strokeWidth={3}
              />
            </LineChart>
          </ResponsiveContainer>
        </Card>
      </Col>

      {/* Equity Curve */}
<Col xs={24} lg={12}>
        <Card title="Equity Curve">
          <ResponsiveContainer width="100%" height={250}>
            <AreaChart data={areaData}>
              {/* <CartesianGrid strokeDasharray="3 3" /> */}
              <XAxis dataKey="day" />
              <YAxis />
              <Tooltip content={<CustomStrategyTooltip />} />
              {/* <Tooltip /> */}
              <Area
                type="monotone"
                dataKey="pnl"
                stroke="#2ecc71"
                fill="#3d8d5e"
                fillOpacity={0.3}
              />
            </AreaChart>
          </ResponsiveContainer>
        </Card>
      </Col>

      {/* Win vs Loss */}
<Col xs={24} lg={12}>
        <Card title="Win vs Loss">
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={barData}>
              {/* <CartesianGrid strokeDasharray="3 3" /> */}
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip content={<CustomStrategyTooltip />} />
              {/* <Tooltip /> */}
              <Bar dataKey="value" fill="#27ae60" barSize={50}     background={{ fill: "transparent" }}

 />
            </BarChart>
          </ResponsiveContainer>
        </Card>
      </Col>
<Col xs={24} lg={12}>
          {/* <ResponsiveContainer width="100%" height={250}> */}
<InsightsCard strategyId={data?.strategy_id} />
          {/* </ResponsiveContainer> */}
      </Col>
<Col xs={24} lg={24}>
          {/* <ResponsiveContainer width="100%" height={250}> */}
<TradesSection data={data} />
          {/* </ResponsiveContainer> */}
      </Col>
    </>
  );
};

export default DashboardCharts;